if($('.brand-highlights').length) {

    $('.brand-highlights').each((i, e) => {

        let sliderContainer = $(e).find('.brand-highlights-carousel-container');

        console.log(sliderContainer.length);

        sliderContainer.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {breakpoint: 1200, settings: {slidesToShow: 3}},
                {breakpoint: 991, settings: {slidesToShow: 2}},
            ]
        });

    });

    function sizeSlideItems() {
        $('.brand-highlights-carousel-container .slick-slide').css('height', '');
        $('.brand-highlights-carousel-container .slick-slide').css('height', $('.brand-highlights-carousel-container').height() + 'px');
    }

    $(window).on('load', function () {sizeSlideItems()});
    $(window).on('resize', function () {sizeSlideItems()});

}
